export default "__VITE_ASSET__C1sKV0yt__"